(() => {
  class ProductDrawer {
    constructor(section) {
      this.section = section;
      this.drawer = section.querySelector('[data-plant-drawer]');
      this.openButton = section.querySelector('[data-plant-drawer-open]');
      this.closeButtons = Array.from(
        section.querySelectorAll('[data-plant-drawer-close]')
      );
      this.lastTrigger = null;

      this.handleOpen = this.open.bind(this);
      this.handleClose = this.close.bind(this);
      this.handleKeydown = this.onKeydown.bind(this);

      this.bindEvents();
    }

    bindEvents() {
      this.openButton?.addEventListener('click', this.handleOpen);
      this.closeButtons.forEach((button) => {
        button.addEventListener('click', this.handleClose);
      });
      this.drawer?.addEventListener('keydown', this.handleKeydown);
    }

    getFocusableElements() {
      if (!this.drawer) return [];

      return Array.from(
        this.drawer.querySelectorAll(
          [
            'a[href]',
            'button:not([disabled])',
            'input:not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            '[tabindex]:not([tabindex="-1"])',
          ].join(',')
        )
      ).filter((element) => element.offsetParent !== null);
    }

    open() {
      if (!this.drawer) return;

      this.lastTrigger = document.activeElement;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.openButton?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('plant-drawer-open');

      window.setTimeout(() => {
        this.getFocusableElements()[0]?.focus();
      }, 50);
    }

    close() {
      if (!this.drawer) return;

      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.openButton?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('plant-drawer-open');

      if (this.lastTrigger && typeof this.lastTrigger.focus === 'function') {
        this.lastTrigger.focus();
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusableElements = this.getFocusableElements();
      if (!focusableElements.length) return;

      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }

    destroy() {
      if (this.drawer?.getAttribute('aria-hidden') === 'false') {
        this.close();
      }

      this.openButton?.removeEventListener('click', this.handleOpen);
      this.closeButtons.forEach((button) => {
        button.removeEventListener('click', this.handleClose);
      });
      this.drawer?.removeEventListener('keydown', this.handleKeydown);
    }
  }

  window.ProductDrawer = {
    create(section) {
      if (!section?.querySelector('[data-plant-drawer]')) return null;
      return new ProductDrawer(section);
    },
  };
})();
